import { Badge, Form, Input, Skeleton, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useVacationsQuery } from 'app/services/edpApiV1/vacations';
import { NavigatesAndAgreement } from 'features/vacations/navigatesAndAgreement';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { dataObjectForTable, dataObjectForVacationTable } from 'shared/helpers/utils';
import { usePath } from 'shared/hooks';
import { PresetStatusColorType } from 'antd/lib/_util/colors';
import SuperviserApproveMarker from 'shared/components/superviserApproveMarker';
import { TPreparedVacationData, TPreparedVacationTableData, TVacationInfo } from 'shared/types/vacations.types';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import VacationsComments from '../vacationsComments';
import style from './index.module.scss';

/**
 * @page Vacation user subordinates archive
 */

const columns: ColumnsType<TPreparedVacationTableData> = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Дата',
    dataIndex: 'created',
    key: 'created',
  },
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Вид отпуска',
    dataIndex: 'vacationType',
    key: 'vacationType',
  },
  {
    title: 'Тип заявления',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Дата начала',
    dataIndex: 'startedAt',
    key: 'startedAt',
  },
  {
    title: 'Дата окончания',
    dataIndex: 'endedAt',
    key: 'endedAt',
  },
  {
    title: 'Дни',
    dataIndex: 'amountDays',
    key: 'amountDays',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: (status: { type?: PresetStatusColorType; text: string; isSupervisorApproved: boolean }) => (
      <span className="d-flex">
        <Badge className={style.badge} status={status.type} />
        {status.text}
      </span>
    ),
  },
];

const VacationUserSubordibationArchive = () => {
  const { id } = useParams();
  const path = usePath(2);
  const [form] = Form.useForm();
  const [dataVacations, setDataVacations] = useState<TPreparedVacationData[] | []>([]);
  const tableData = useRef<TPreparedVacationTableData[]>();
  const location = useLocation();
  const currentLocationState = location?.state as { page: number; size: number } | null;
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const { data, refetch, isLoading, isFetching, isSuccess } = useVacationsQuery({
    type: 'otherArchive',
    size: currentLocationState?.size ? currentLocationState.size : 10,
    page: currentLocationState?.page ? currentLocationState.page : 1,
    allAvailableOrganizations,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (data && id) {
      const dataNew = data?.data?.find((el: TVacationInfo) => el.id === Number(id));
      const dataTable = dataObjectForTable(dataNew);
      const dataForTable = dataObjectForVacationTable(dataNew);
      if (dataForTable) {
        tableData.current = dataForTable;
      }
      if (dataTable) {
        setDataVacations(dataTable);
      }
    }
  }, [data, id]);

  useEffect(() => {
    if (dataVacations && dataVacations?.length > 0) {
      form.setFields([
        {
          name: 'tabel',
          value: dataVacations[0]?.employee?.personnelNumber,
        },
        {
          name: 'division',
          value: dataVacations[0]?.employee?.division,
        },
        {
          name: 'position',
          value: dataVacations[0]?.employee?.position,
        },
      ]);
    }
  }, [dataVacations, form]);

  return (
    <>
      <div className={style.wrap}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            {id && path === 'archive' && <NavigatesAndAgreement id={id} tabKey="otherArchive" />}

            <Table scroll={{ x: true }} dataSource={tableData.current} columns={columns} pagination={false} bordered />

            <Form form={form} layout="vertical" name="userInfo" className={style.userInfo}>
              <div className={style.groupItem}>
                <Form.Item name="tabel" label="Табельный номер" labelAlign="left" className={style.inputWrap}>
                  <Input className="userInput" disabled />
                </Form.Item>
                <Form.Item name="division" label="Подразделение" labelAlign="left" className={style.inputWrap}>
                  <Input className="userInput" disabled />
                </Form.Item>
              </div>
              <div className={style.groupItem}>
                <Form.Item name="position" label="Должность" labelAlign="left" className={style.inputWrap}>
                  <Input className="userInput" disabled />
                </Form.Item>
              </div>
            </Form>
          </>
        )}
      </div>
      {dataVacations && dataVacations[0]?.status?.text === 'Отклонено HR' && (
        <VacationsComments commentsData={dataVacations[0]?.rejectionReason} />
      )}
    </>
  );
};

export default VacationUserSubordibationArchive;
